import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PaymentRequest } from '../models/paymentrequest.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private apiUrl = environment.apiBaseUrl +'/api/payments';

  constructor(private http: HttpClient) { }

  // ✅ Place a new payment
  checkout(payment: PaymentRequest): Observable<PaymentRequest> {
    return this.http.post<PaymentRequest>(`${this.apiUrl}/checkout`, payment);
  }


}
